import { useRef } from "react";
import "./OTPInput.css";

function OTPInput({ otp, setOtp }) {

  const inputs = useRef([]);

  const handleChange = (value, index) => {

    if (!/^\d?$/.test(value)) return;

    const newOtp = [...otp];

    newOtp[index] = value;

    setOtp(newOtp);

    if (value && index < 5) {

      inputs.current[index + 1].focus();

    }

  };

  const handleKeyDown = (e, index) => {

    if (

      e.key === "Backspace" &&

      !otp[index] &&

      index > 0

    ) {

      inputs.current[index - 1].focus();

    }

  };

  const handlePaste = (e) => {

    e.preventDefault();

    const paste = e.clipboardData

      .getData("text")

      .replace(/\D/g, "")

      .slice(0, 6);

    const newOtp = [...otp];

    paste.split("").forEach((digit, index) => {

      newOtp[index] = digit;

    });

    setOtp(newOtp);

  };

  return (

    <div

      className="otp-container"

      onPaste={handlePaste}

    >

      {otp.map((digit, index) => (

        <input

          key={index}

          ref={(el) =>

            (inputs.current[index] = el)

          }

          type="text"

          inputMode="numeric"

          maxLength="1"

          value={digit}

          onChange={(e) =>

            handleChange(

              e.target.value,

              index

            )

          }

          onKeyDown={(e) =>

            handleKeyDown(

              e,

              index

            )

          }

        />

      ))}

    </div>

  );

}

export default OTPInput;